import React from 'react';
import PropTypes from 'prop-types';
// material-ui
import Tooltip from '@material-ui/core/Tooltip';
// css
import './FontIcon.scss';

// const Icon = ({
// 	icon, size, cursor, color, tooltip, placement
// }) => {
// 	let className = "Icon ";
// 	className += icon ? `icon-${icon}` : " default";
// 	className += size ? ` ${size}` : "";
// 	className += (cursor) || (cursor === undefined) ? " pointer" : "";
// 	className += color ? ` ${color}` : "";
// 	if ((icon === "add_doc") || (icon === "add_msg")) {
// 		return (
// 			<span className={className}>
// 				<span className="path1" />
// 				<span className="path2" />
// 			</span>
// 		);
// 	}
// 	return (
// 		<Tooltip title={tooltip} placement={placement}>
// 			<span className={className} />
// 		</Tooltip>
// 	);
// };

const FontIcon = ({
	tooltip, placement, iconName, size, color
}) => {
	return (
		<Tooltip title={tooltip} placement={placement}>
			<span className={`FontIcon icon-${iconName} ${size}`} style={{color: color}} />
		</Tooltip>
	);
};

FontIcon.propTypes = {
	tooltip: PropTypes.node,
	placement: PropTypes.string,
	size: PropTypes.string,
	color: PropTypes.string,
	iconName: PropTypes.string
};

FontIcon.defaultProps = {
	tooltip: '',
	placement: 'bottom',
	size: 'default',
	color: '',
	iconName: ''
};

export default FontIcon;



// WEBPACK FOOTER //
// ./common/FontIcon/FontIcon.js